<template>
  <section class="category-page-section">
    <div class="wrapper">
      <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="title-banner detail-title-banner">
              <div class="title-content" v-if="bulletin">
                <h1 class="detail-head">
                  {{ bulletin.productName }}
                </h1>
                <div class="address-section">
                  <p class="footer-add">
                    <router-link to="/">
                      {{ translations.home_lite }}
                    </router-link>
                  </p>
                  <img
                    src="../assets/images/next-page.svg"
                    alt="next-icon"
                    class="next-page"
                    loading="lazy"
                  />

                  <p class="footer-add">
                    <router-link :to="{ path: '/bulletIn/list',}">
                      {{ translations.bulletin }}
                    </router-link>
                  </p>
                  <img
                    src="../assets/images/next-page.svg"
                    alt="next-icon"
                    class="next-page"
                    loading="lazy"
                  />

                  <p class="footer-add">{{ bulletin.categoryNormalized }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12"></div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
        <div class="row just-align">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div v-if="bulletin">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="image-section">
                    <div class="product-detail-image">
                      <img
                        class="product-image"
                        :src="currentImage"
                        :alt="`Bulletin: ${bulletin.productName}`"
                        @click="openImage"
                        @error="handleGalleryImageError"
                        loading="lazy"
                      />
                    </div>

                    <div class="slef-image-div" v-if="allImages.length > 1">
                      <div
                        class="product-detail-sub-image"
                        v-for="(image, index) in allImages"
                        :key="index"
                        @click="selectImage(index)"
                      >
                        <img
                          class="product-image"
                          :src="image"
                          :alt="`Bulletin thumbnail ${index + 1}`"
                          @error="handleThumbnailError"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="information-section">
                    <p
                      class="detail-type"
                      :style="{ backgroundColor: bulletin.type === 'buy' ? '#B0C800' : 'lightskyblue' }"
                    >
                      {{ getTypeLabel(bulletin.type, bulletin.typeNormalized) }}
                    </p>

                    <h2 class="product-name">{{ bulletin.productName }}</h2>

                    <p class="category-type mt-3">
                      {{ translations.category }}:
                      <span @click="navigateToBulletinHome">{{ bulletin.categoryNormalized }}</span>
                    </p>

                    <h4
                      v-if="hasValidPrice(bulletin.price)"
                      class="product-price"
                    >
                      ₹{{ bulletin.price }}/{{ getQuantityType(bulletin) }}
                    </h4>
                    <h4 v-else class="product-price-not">
                      {{ translations.priceNotMentioned }}
                    </h4>
                    <p class="category-type mt-2">
                      {{ translations.quantity }}: {{ bulletin.quantity }}
                    </p>

                    <ContactSellerCard
                      :seller-name="bulletin.userName"
                      :phone-number="bulletin.phoneNumber"
                      :selected-language="selectedLanguage"
                    />

                   

                    <div class="item-info-div">
                      <div class="info-img-div">
                        <img
                          src="../assets/images/detail-component/info.svg"
                          alt="info"
                          loading="lazy"
                        />
                      </div>
                      <div>
                        <p class="item-ids-name">{{ translations.itemId }}</p>
                        <p class="info">#{{ bulletin.id }}</p>
                      </div>
                      <div class="info-img-div">
                        <img
                          src="../assets/images/detail-component/info.svg"
                          alt="info"
                          loading="lazy"
                        />
                      </div>
                      <div>
                        <p class="item-ids-name">{{ translations.posted }}</p>
                        <p class="info">{{ formatDate(bulletin.createdAt) }}</p>
                      </div>
                    </div>

                    <div class="address-div">
                      <div class="address-img-div">
                        <img
                          src="../assets/images/detail-component/location.svg"
                          alt="location"
                          loading="lazy"
                        />
                      </div>
                      <p>{{ getLocationText(bulletin) }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="review-div">
                    <div class="review-heading-div">
                      <p
                        class="review-heading"
                        v-for="(tab, index) in tabs"
                        :key="index"
                        :class="{ active: activeTab === tab.name }"
                        @click="setActiveTab(tab.name)"
                      >
                        {{ tab.label }}
                      </p>
                    </div>
                    <div class="review-content-div">
                      <p class="content" v-if="activeTab === 'description'">
                        {{ bulletin.description || translations.noDescription }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div :class="{ 'categories_head-tamil-fonts': selectedLanguage === 'ta', 'categories_head': selectedLanguage !== 'ta' }">
                    <h3 :class="{ 'popular-tamil-fonts': selectedLanguage === 'ta', 'popular-title': selectedLanguage !== 'ta' }">
                      {{ translations.bulletin }}
                    </h3>
                  </div>
                  <div class="for_detail-btn">
                    <button
                      type="button"
                      class="carousel-nav-btn"
                      :class="{ disabled: isAtStart }"
                      :disabled="isAtStart"
                      @click="scrollLeft"
                    >
                      <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <button
                      type="button"
                      class="carousel-nav-btn"
                      :class="{ disabled: isAtEnd }"
                      :disabled="isAtEnd"
                      @click="scrollRight"
                    >
                      <i class="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>

                  <div class="row" v-if="relatedBulletins.length > 0">
                    <div v-if="isRelatedLoading">
                      <div class="loader">
                        <div class="row">
                          <div
                            v-for="n in 4"
                            :key="n"
                            class="col-lg-12 col-md-12 col-sm-12"
                          >
                            <p class="shimmer-line-img"></p>
                            <p class="shimmer-line"></p>
                            <p class="shimmer-line"></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-else
                      class="side-product-container"
                      ref="scrollContainer"
                      @scroll="updateScrollButtons"
                    >
                      <div
                        class="col-lg-4 col-md-4 col-sm-12 for-flex-align"
                        v-for="item in relatedBulletins.slice(0, 8)"
                        :key="item.id"
                      >
                        <router-link :to="getBulletinRoute(item)" target="_blank">
                          <div class="product">
                            <div class="img_div">
                              <img
                                :src="getBulletinImage(item)"
                                :alt="`Bulletin-${item.id}`"
                                @error="handleImageError"
                                loading="lazy"
                              />
                            </div>
                            <p
                              :class="{ 'type_tamil': selectedLanguage === 'ta', 'type': selectedLanguage !== 'ta' }"
                              :style="{ backgroundColor: item.type === 'buy' ? '#B0C800' : 'lightskyblue' }"
                            >
                              {{ getTypeLabel(item.type, item.typeNormalized) }}
                            </p>

                            <div class="align">
                              <p :class="{ 'sub_category_name_tamil': selectedLanguage === 'ta', 'sub_category_name': selectedLanguage !== 'ta' }">
                                {{ item.categoryNormalized }}
                              </p>
                              <p class="product-name">{{ item.productName }}</p>

                              <div class="date-location">
                                <div>
                                  <p :class="{ 'location_name_d_tamil': selectedLanguage === 'ta', 'loction-data_d': selectedLanguage !== 'ta' }">
                                    <span>
                                      <img src="../assets/images/location-icon.svg" alt="location" loading="lazy" />
                                    </span>
                                    {{ getLocationText(item) }}
                                  </p>
                                </div>
                                <div>
                                  <p class="created">{{ formatCardDate(item.createdAt) }}</p>
                                </div>
                              </div>

                              <div class="price-view">
                                <div>
                                  <p :class="{ 'price_tamil': selectedLanguage === 'ta', 'price': selectedLanguage !== 'ta' }">
                                    {{ getPriceText(item) }}
                                  </p>
                                </div>
                                <div>
                                  <a>
                                    <button :class="{ 'price_button_tamil': selectedLanguage === 'ta', 'price_button': selectedLanguage !== 'ta' }">
                                      {{ translations.viewmore }}
                                    </button>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div v-if="isRelatedLoading">
                      <div class="loader">
                        <div class="row">
                          <div
                            v-for="n in 4"
                            :key="n"
                            class="col-lg-12 col-md-12 col-sm-12"
                          >
                            <p class="shimmer-line-img"></p>
                            <p class="shimmer-line"></p>
                            <p class="shimmer-line"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="nodata-img">
                        <img
                          src="../assets/images/emptypro.webp"
                          loading="lazy"
                          alt="empty"
                        />
                      </div>
                      <h2 class="my-3 no-data">Bulletin Not Available!!</h2>
                      <p class="no-data-para">
                        No requirement available currently, come back later . To post requirement download our app.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="isLoading" class="loading-spinner">
              <div class="row">
                <div class="col-lg-6">
                  <p class="shimmer-line" style="height: 300px"></p>
                  <div class="row d-flex">
                    <div class="col my-2 mx-1" v-for="n in 5" :key="n">
                      <p class="shimmer-line" style="height: 50px"></p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <p class="shimmer-line my-2" style="height: 50px"></p>
                  <p class="shimmer-line" style="height: 100px"></p>
                  <p class="shimmer-line my-2" style="height: 20px"></p>
                  <p class="shimmer-line" style="height: 40px"></p>
                  <p class="shimmer-line my-2" style="height: 20px"></p>
                  <p class="shimmer-line" style="height: 40px"></p>
                </div>
                <div class="col-sm-12">
                  <p class="shimmer-line my-2" style="height: 50px"></p>
                  <p class="shimmer-line" style="height: 100px"></p>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="nodata-img">
                <img
                  src="../assets/images/emptypro.webp"
                  loading="lazy"
                  alt="empty"
                />
              </div>
              <h2 class="my-3 no-data">{{ translations.bulletinNotFound }}</h2>
              <p class="no-data-para">
                No requirement available currently, come back later . To post requirement download our app.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div v-if="showImage" class="modal">
        <div class="modal-content">
          <button class="close-button" @click="closeImage">
            <i class="fa-solid fa-x"></i>
          </button>
          <div class="showimg">
            <img
              v-if="selectedImageIndex !== null"
              :src="allImages[selectedImageIndex]"
              alt="Selected Bulletin Image"
              loading="lazy"
              class="selected-image"
            />
            <button
              v-if="selectedImageIndex > 0"
              @click="changeImage(-1)"
              class="prev-button"
            >
              &#10094;
            </button>
            <button
              v-if="selectedImageIndex < allImages.length - 1"
              @click="changeImage(1)"
              class="next-button"
            >
              &#10095;
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import ContactSellerCard from "./ContactSellerCard.vue";
import { en, ta } from "../translations";

const FALLBACK_IMAGE = require("../assets/images/No-Data-list.webp");
const API_BASE_URL = "https://vaiyal-app.herokuapp.com";

export default {
  name: "BulletinDetail",
  components: {
    ContactSellerCard,
  },
  props: {
    selectedLanguage: String,
  },
  data() {
    return {
      bulletin: null,
      relatedBulletins: [],
      isLoading: true,
      isRelatedLoading: false,
      selectedImageIndex: 0,
      showImage: false,
      activeTab: "description",
      tabs: [{ name: "description", label: "Description" }],
      isAtStart: true,
      isAtEnd: false,
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    },
    allImages() {
      if (!this.bulletin) {
        return [FALLBACK_IMAGE];
      }

      const images = Array.isArray(this.bulletin.images)
        ? this.bulletin.images.filter(Boolean)
        : [];

      return images.length > 0 ? images : [FALLBACK_IMAGE];
    },
    currentImage() {
      return this.allImages[this.selectedImageIndex] || FALLBACK_IMAGE;
    },
  },
  watch: {
    "$route.params.id": function (newId, oldId) {
      if (newId !== oldId) {
        this.loadDetailPage(newId);
      }
    },
    showImage(newValue) {
      document.body.style.overflow = newValue ? "hidden" : "auto";
    },
  },
  created() {
    this.loadDetailPage(this.$route.params.id);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    document.body.style.overflow = "auto";
  },
  methods: {
    scrollLeft() {
      if (!this.$refs.scrollContainer) {
        return;
      }
      const distance = this.getScrollDistance();
      this.$refs.scrollContainer.scrollBy({ left: -distance, behavior: "smooth" });
      setTimeout(() => this.updateScrollButtons(), 250);
    },
    scrollRight() {
      if (!this.$refs.scrollContainer) {
        return;
      }
      const distance = this.getScrollDistance();
      this.$refs.scrollContainer.scrollBy({ left: distance, behavior: "smooth" });
      setTimeout(() => this.updateScrollButtons(), 250);
    },
    getScrollDistance() {
      const container = this.$refs.scrollContainer;
      if (!container) {
        return 350;
      }

      const styles = window.getComputedStyle(container);
      const gapValue = styles.columnGap || styles.gap || "0";
      const gap = Number.parseFloat(gapValue) || 0;
      return (container.clientWidth || 350) + gap;
    },
    updateScrollButtons() {
      const container = this.$refs.scrollContainer;
      if (!container) {
        this.isAtStart = true;
        this.isAtEnd = true;
        return;
      }

      const maxScrollLeft = Math.max(container.scrollWidth - container.clientWidth, 0);
      this.isAtStart = container.scrollLeft <= 2;
      this.isAtEnd = container.scrollLeft >= maxScrollLeft - 2;
    },
    handleResize() {
      this.$nextTick(() => {
        this.updateScrollButtons();
      });
    },
    async loadDetailPage(id) {
      if (!id) {
        this.bulletin = null;
        return;
      }

      await this.fetchBulletinDetail(id);
      await this.fetchRelatedBulletins();
    },
    async fetchBulletinDetail(id) {
      this.isLoading = true;
      try {
        const response = await axios.get(`${API_BASE_URL}/getbulletin/${id}`);
        const payload = response?.data?.data;

        if (response?.data?.status === "success" && payload) {
          this.bulletin = this.mapBulletinDetail(payload);
          this.selectedImageIndex = 0;
          this.syncRouteWithBulletin();
          document.title = `${this.bulletin.productName} - VayalAgro Bulletin`;
        } else {
          this.bulletin = null;
        }
      } catch (error) {
        console.error("Error fetching bulletin detail:", error);
        this.bulletin = null;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchRelatedBulletins() {
      if (!this.bulletin) {
        this.relatedBulletins = [];
        return;
      }

      this.isRelatedLoading = true;
      try {
        const params = this.bulletin.type ? { type: this.bulletin.type } : {};
        const response = await axios.get(`${API_BASE_URL}/listbulletin`, { params });
        const list = Array.isArray(response?.data?.data) ? response.data.data : [];

        this.relatedBulletins = list
          .map(this.mapBulletinListItem)
          .filter((item) => String(item.id) !== String(this.bulletin.id));
      } catch (error) {
        console.error("Error fetching related bulletins:", error);
        this.relatedBulletins = [];
      } finally {
        this.isRelatedLoading = false;
        this.$nextTick(() => {
          this.updateScrollButtons();
        });
      }
    },
    mapBulletinDetail(item) {
      const images = this.getImageUrls(item);

      return {
        id: item.id,
        type: String(item.type || "").toLowerCase(),
        typeNormalized: item.type_normalized || this.getTypeLabel(item.type),
        level: String(item.level || "").toLowerCase(),
        levelNormalized: item.level_normalized,
        categoryNormalized: item.category_normalized || this.formatCategory(item.category),
        productName: item.product_name || "No Name",
        description: item.description || "",
        districtName: item.district_name || "Tamilnadu",
        districtTamilName: item.district_tn_name || item.district_name || "Tamilnadu",
        placeName: item.place_name || "",
        placeTamilName: item.place_tn_name || item.place_name || "",
        quantity: item.quantity ?? 0,
        price: item.price ?? "",
        quantityType: item.quantity_type || "",
        quantityTypeTamil: item.quantity_type_tamil || item.quantity_type || "",
        image: images[0] || FALLBACK_IMAGE,
        images,
        createdAt: item.created_at,
        userName: item.user_name || "",
        phoneNumber: item.phone_number || "",
      };
    },
    mapBulletinListItem(item) {
      const images = this.getImageUrls(item);

      return {
        id: item.id,
        type: String(item.type || "").toLowerCase(),
        typeNormalized: item.type_normalized || this.getTypeLabel(item.type),
        level: String(item.level || "").toLowerCase(),
        levelNormalized: item.level_normalized,
        categoryNormalized: item.category_normalized || this.formatCategory(item.category),
        productName: item.product_name || "No Name",
        description: item.description || "",
        districtName: item.district_name || "Tamilnadu",
        districtTamilName: item.district_tn_name || item.district_name || "Tamilnadu",
        placeName: item.place_name || "",
        placeTamilName: item.place_tn_name || item.place_name || "",
        quantity: item.quantity ?? 0,
        price: item.price ?? "",
        quantityType: item.quantity_type || "",
        quantityTypeTamil: item.quantity_type_tamil || item.quantity_type || "",
        image: images[0] || FALLBACK_IMAGE,
        createdAt: item.created_at,
      };
    },
    getImageUrls(item) {
      const rawImages = item?.image_url ?? item?.ImageUrl ?? item?.additional_images;

      if (Array.isArray(rawImages)) {
        return rawImages.filter(Boolean);
      }

      if (typeof rawImages === "string" && rawImages.trim()) {
        return [rawImages];
      }

      return [];
    },
    formatCategory(value) {
      if (!value) return "N/A";
      return value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
    selectImage(index) {
      this.selectedImageIndex = index;
    },
    openImage() {
      this.showImage = true;
    },
    closeImage() {
      this.showImage = false;
    },
    changeImage(direction) {
      const newIndex = this.selectedImageIndex + direction;
      if (newIndex >= 0 && newIndex < this.allImages.length) {
        this.selectedImageIndex = newIndex;
      }
    },
    handleImageError(event) {
      event.target.src = FALLBACK_IMAGE;
    },
    handleGalleryImageError(event) {
      event.target.src = FALLBACK_IMAGE;
    },
    handleThumbnailError(event) {
      event.target.src = FALLBACK_IMAGE;
    },
    getBulletinImage(item) {
      return item.image || FALLBACK_IMAGE;
    },
    getTypeLabel(type, normalized = "") {
      if (normalized) return normalized;
      const normalizedType = String(type || "").toLowerCase();
      if (normalizedType === "buy") return this.translations.buy;
      if (normalizedType === "sell") return this.translations.sell;
      return "N/A";
    },
    getQuantityType(item) {
      if (this.selectedLanguage === "ta") {
        return item.quantityTypeTamil || item.quantityType;
      }

      return item.quantityType;
    },
    hasValidPrice(price) {
      const normalized = String(price ?? "").trim();
      return normalized !== "" && Number.isFinite(Number(normalized)) && Number(normalized) !== 0;
    },
    getPriceText(item) {
      if (!this.hasValidPrice(item.price)) {
        return this.translations.prnm || this.translations.priceNotMentioned;
      }

      const quantityType = this.getQuantityType(item);
      return quantityType ? `₹${item.price}/${quantityType}` : `₹${item.price}`;
    },
    getLocationText(item) {
      const district =
        this.selectedLanguage === "ta" ? item.districtTamilName : item.districtName;
      const place = this.selectedLanguage === "ta" ? item.placeTamilName : item.placeName;

      if (place) {
        return `${place}, ${district}`;
      }

      return district;
    },
    formatDate(date) {
      if (!date) return "";
      const dateObject = new Date(date);
      const day = String(dateObject.getDate()).padStart(2, "0");
      const month = String(dateObject.getMonth() + 1).padStart(2, "0");
      const year = dateObject.getFullYear();
      return `${day}-${month}-${year}`;
    },
    formatCardDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
    },
    navigateToBulletinHome() {
      this.$router.push({ path: "/", hash: "#bulletin-section" });
    },
    formatRouteSegment(value, fallback = "item") {
      const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

      return normalized || fallback;
    },
    getBulletinRoute(bulletin) {
      return {
        name: "BulletinDetail",
        params: {
          location: this.formatRouteSegment(bulletin.districtName, "tamilnadu"),
          category: "bulletins",
          categoryName: this.formatRouteSegment(bulletin.categoryNormalized, "bulletin"),
          bulletin: this.formatRouteSegment(
            bulletin.productName || bulletin.categoryNormalized,
            "bulletin"
          ),
          id: String(bulletin.id),
        },
      };
    },
    syncRouteWithBulletin() {
      if (!this.bulletin || this.$route.name !== "BulletinDetail") {
        return;
      }

      const expectedParams = {
        location: this.formatRouteSegment(this.bulletin.districtName, "tamilnadu"),
        category: "bulletins",
        categoryName: this.formatRouteSegment(this.bulletin.categoryNormalized, "bulletin"),
        bulletin: this.formatRouteSegment(
          this.bulletin.productName || this.bulletin.categoryNormalized,
          "bulletin"
        ),
      };

      const routeKeys = ["location", "category", "categoryName", "bulletin"];
      const needsRouteUpdate = routeKeys.some(
        (key) => this.$route.params[key] !== expectedParams[key]
      );

      if (needsRouteUpdate) {
        this.$router.replace({
          name: "BulletinDetail",
          params: {
            ...this.$route.params,
            ...expectedParams,
            id: String(this.bulletin.id),
          },
        });
      }
    },
  },
};
</script>

<style>
@import url("/src/components/CategoryPage.scss");
@import url("/src/components/DetailComponent.scss");
@import url("/src/components/BulletinDetail.scss");
</style>
